import { Expose } from 'class-transformer';
import { DefaultIncrementViewDto } from '../../../common/dto/default-increment-view.dto';

export class ViewDeliveryRouteDto extends DefaultIncrementViewDto {
  @Expose() name: string;
  @Expose() description: string;
}
